import Image from "next/image";

const DesktopThumbOnPulse = () => {
  return (
    <div className="flex flex-col px-20 xl:px-36 space-y-5 xl:space-y-10 pb-12">
      <div className="py-16 w-full flex items-center justify-center">
        <div className="flex flex-col space-y-3 text-center">
          <p className="subheading text-text-color-mid-em-light">Industry solutions specific to your business.</p>
          <p className="h2 xl:h1 text-text-color-high-em-light">Thumb on the pulse</p>
        </div>
      </div>
      <div className="space-y-20">
        <div className="flex flex-row space-x-12 justify-center ">
          <div className="w-1/2">
            <Image
              src="/images/industries/data-driven.png"
              alt="data-driven"
              width={560}
              height={340}
            />
          </div>
          <div className="flex w-1/2 flex-col items-center justify-center">
            <div className="space-y-3 xl:space-y-5">
              <p className="h4 xl:h3 text-text-color-high-em-light">Data-driven solutions</p>
              <div className="text-text-color-mid-em-light flex flex-col space-y-2 xl:space-y-5">
                <p>
                  Our industry solutions portfolio utilizes a wide array of options specific to your business, waste profiles, and facility type.
                  Find the solution that&apos;s right for you.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-row space-x-8 xl:space-x-28 justify-center ">
          <div className="flex w-1/2 items-center justify-center flex-col">
            <div className="space-y-3 xl:space-y-5">
              <p className="h4 xl:h3 text-text-color-high-em-light">
                Technology Integration
              </p>
              <div className="text-text-color-mid-em-light flex flex-col space-y-2 xl:space-y-5">
                <p>
                  Power your operations with our technology stack.
                  Consolidate the management of your programs, services, and vendors with our platform.
                </p>
              </div>
            </div>
          </div>
          <div className="w-1/2">
            <Image
              src="/images/industries/tech-integ.png"
              alt="tech-integ"
              width={560}
              height={432}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default DesktopThumbOnPulse;
